<template>
  <div>
    <van-nav-bar :right-text="username" left-arrow left-text="返回" title="出库复核" @click-left="onClickLeft" @click-right="goIndex()"/>
    <van-cell-group>
      <van-field ref="barcode" v-model="barcode" autofocus label="条码" left-icon="photograph" placeholder="请扫描暂存区" @keyup="onBarcode"/>
    </van-cell-group>
    <a-table :dataSource="list" :loading="loading" :pagination="false" :rowKey="(rec) => rec.index" bordered size="middle">
      <a-table-column align="center" dataIndex="order.stagingArea" title="暂存区"/>
      <a-table-column align="center" dataIndex="order.ordersCount" title="剩余任务数"/>
    </a-table>
    <van-tabbar fixed placeholder>
      <van-tabbar-item>
        <van-row gutter="20">
          <van-col span="10">
            <van-button block native-type="search" round style="margin: 10px;" type="info" @click="refresh">刷新</van-button>
          </van-col>
          <van-col span="10">
            <van-button :loading="loading" block native-type="toView" round style="margin: 10px;" type="info" @click="view">查看</van-button>
          </van-col>
        </van-row>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
import { findAll } from '@/api/Api'
import { getUser, getWarehouseId } from '@/pdaView/utils'
import { Toast } from 'vant'
import debounce from 'lodash/debounce'

export default {
  name: 'ReviewHall',
  data() {
    return {
      loading: false,
      username: getUser().name,
      selectedRowKeys: [],
      selectedRows: {},
      list: [],
      barcode: null
    }
  },
  methods: {
    onBarcode: debounce(function(data, event) {
      if ([13].includes(data.keyCode)) {
        const value = _.trim(data.target.value)
        this.view(value)
      }
    }, 300),
    onClickLeft() {
      this.$router.push({ name: 'PdaIndex' })
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.handleCheck()
    },
    handleCheck(record, index) {
      return {
        on: {
          click: () => {
            this.selectedRowKeys = [index]
            this.selectedRows = record
          }
        }
      }
    },
    goIndex() {
      this.$router.push({ name: 'PdaIndex' })
    },
    refresh() {
      findAll('reviewOverviewFactory', { 'warehouse.id': getWarehouseId() }).then(res => {
        this.list = res.result
      })
    },
    view(barcode) {
      if (barcode) {
        this.$router.push({ name: 'StagingArea', params: { barcode: barcode } })
      } else {
        Toast('请先输入暂存区')
      }
    }
  },
  created: function() { // 创建生命周期
    this.refresh()
  }
}
</script>